<template>
    <p class="mt-6 text-lg/8 text-gray-600 dark:text-gray-300"><slot></slot></p>
</template>
